import { createFileRoute, redirect } from '@tanstack/react-router'
import { Route as ScheduledAutomationsRoute } from '@routes/_auth/o/$orgId/automations/scheduled'

export const Route = createFileRoute('/_auth/o/$orgId/automations/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: ScheduledAutomationsRoute.to,
      params: { orgId: params.orgId },
      replace: true,
    })
  },
})
